import { getErrorMessage } from "../utils/commonUtils";
import {
  useGetMckessonVendorDetailMutation,
  useGetMckessonShippingLocationsMutation,
  useGetMckessonApisMutation,
  usePostMckessonApiMutation,
  usePutMckessonApiMutation,
  useDeleteMckessonApiMutation,
  usePostMckessonVendorDetailMutation,
  usePutMckessonVendorDetailMutation,
  usePostMckessonShippingLocationMutation,
  usePutMckessonShippingLocationMutation,
  useDeleteMckessonShippingLocationMutation,
  useGetMckessonEdiFileListMutation,
  useGetMckessonEdiItemListMutation,
  useGetMckessonEdiHeaderListMutation,
  useGetMckessonOrderFilesMutation,
  useGetMckessonOrderDataItemsMutation,
  useFetchMckessonOrderItemMutation,
  useMarkMckessonOrderProcessedMutation,
  useGetMckessonItemsMutation,
  useGetMckessonUomsMutation,
  usePostMckessonItemSearchMutation,
  usePostMckessonItemFeedMutation,
  usePostMckessonItemLookupMutation,
} from "../redux/mckesson/mckessonApiSlice";
import { toast } from "react-toastify";

export default function useMckesson() {
  // Vendor Detail
  const [getMckessonVendorDetail, { isLoading: getMckessonVendorDetailLoading }] =
    useGetMckessonVendorDetailMutation();
  const [postMckessonVendorDetail, { isLoading: postMckessonVendorDetailLoading }] =
    usePostMckessonVendorDetailMutation();
  const [putMckessonVendorDetail, { isLoading: putMckessonVendorDetailLoading }] =
    usePutMckessonVendorDetailMutation();

  // Shipping Locations
  const [getMckessonShippingLocations, { isLoading: getMckessonShippingLocationsLoading }] =
    useGetMckessonShippingLocationsMutation();
  const [postMckessonShippingLocation, { isLoading: postMckessonShippingLocationLoading }] =
    usePostMckessonShippingLocationMutation();
  const [putMckessonShippingLocation, { isLoading: putMckessonShippingLocationLoading }] =
    usePutMckessonShippingLocationMutation();
  const [deleteMckessonShippingLocation, { isLoading: deleteMckessonShippingLocationLoading }] =
    useDeleteMckessonShippingLocationMutation();

  // APIs
  const [getMckessonApis, { isLoading: getMckessonApisLoading }] =
    useGetMckessonApisMutation();
  const [postMckessonApi, { isLoading: postMckessonApiLoading }] =
    usePostMckessonApiMutation();
  const [putMckessonApi, { isLoading: putMckessonApiLoading }] =
    usePutMckessonApiMutation();
  const [deleteMckessonApi, { isLoading: deleteMckessonApiLoading }] =
    useDeleteMckessonApiMutation();

  // EDI / Order Processor
  const [getMckessonEdiFileList, { isLoading: getMckessonEdiFileListLoading }] =
    useGetMckessonEdiFileListMutation();
  const [getMckessonEdiItemList, { isLoading: getMckessonEdiItemListLoading }] =
    useGetMckessonEdiItemListMutation();
  const [getMckessonOrderFiles, { isLoading: getMckessonOrderFilesLoading }] =
    useGetMckessonOrderFilesMutation();
  const [getMckessonOrderDataItems, { isLoading: getMckessonOrderDataItemsLoading }] =
    useGetMckessonOrderDataItemsMutation();
  const [fetchMckessonOrderItem, { isLoading: fetchMckessonOrderItemLoading }] =
    useFetchMckessonOrderItemMutation();
  const [markMckessonOrderProcessed, { isLoading: markMckessonOrderProcessedLoading }] =
    useMarkMckessonOrderProcessedMutation();
  const [getMckessonEdiHeaderList, { isLoading: getMckessonEdiHeaderListLoading }] =
    useGetMckessonEdiHeaderListMutation();

  // Items Master
  const [getMckessonItems, { isLoading: getMckessonItemsLoading }] =
    useGetMckessonItemsMutation();
  const [getMckessonUoms, { isLoading: getMckessonUomsLoading }] =
    useGetMckessonUomsMutation();
  const [postMckessonItemSearch, { isLoading: postMckessonItemSearchLoading }] =
    usePostMckessonItemSearchMutation();
  const [postMckessonItemFeed, { isLoading: postMckessonItemFeedLoading }] =
    usePostMckessonItemFeedMutation();
  const [postMckessonItemLookup, { isLoading: postMckessonItemLookupLoading }] =
    usePostMckessonItemLookupMutation();

  // --- Vendor Detail APIs ---
  const getMckessonVendorDetailAPI = async () => {
    try {
      const response: any = await getMckessonVendorDetail({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonVendorDetailAPI = async (data: any) => {
    try {
      const response: any = await postMckessonVendorDetail(data).unwrap();
      toast.success("Success! Vendor Settings have been Saved.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const putMckessonVendorDetailAPI = async (data: any) => {
    try {
      const response: any = await putMckessonVendorDetail(data).unwrap();
      toast.success("Success! Vendor Settings have been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  // --- Shipping Location APIs ---
  const getMckessonShippingLocationsAPI = async () => {
    try {
      const response: any = await getMckessonShippingLocations({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonShippingLocationAPI = async (data: any) => {
    try {
      const response: any = await postMckessonShippingLocation(data).unwrap();
      toast.success("Success! Shipping Location has been Added.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const putMckessonShippingLocationAPI = async (data: any) => {
    try {
      const response: any = await putMckessonShippingLocation(data).unwrap();
      toast.success("Success! Shipping Location has been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const deleteMckessonShippingLocationAPI = async (data: any) => {
    try {
      const response: any = await deleteMckessonShippingLocation(data).unwrap();
      toast.success("Success! Shipping Location has been Deleted.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  // --- McKesson API URLs ---
  const getMckessonApisAPI = async () => {
    try {
      const response: any = await getMckessonApis({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonApiAPI = async (data: any) => {
    try {
      const response: any = await postMckessonApi(data).unwrap();
      toast.success("Success! URL has been Added.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const putMckessonApiAPI = async (data: any) => {
    try {
      const response: any = await putMckessonApi(data).unwrap();
      toast.success("Success! URL has been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const deleteMckessonApiAPI = async (data: any) => {
    try {
      const response: any = await deleteMckessonApi(data).unwrap();
      toast.success("Success! URL has been Deleted.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  // --- EDI / Order Processor APIs ---
  const getMckessonEdiFileListAPI = async (data: any) => {
    try {
      const response: any = await getMckessonEdiFileList(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getMckessonEdiItemListAPI = async (data: any) => {
    try {
      const response: any = await getMckessonEdiItemList(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getMckessonEdiHeaderListAPI = async (data: any) => {
    try {
      const response: any = await getMckessonEdiHeaderList(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getMckessonOrderFilesAPI = async (data: any) => {
    try {
      const response: any = await getMckessonOrderFiles(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getMckessonOrderDataItemsAPI = async (data: any) => {
    try {
      const response: any = await getMckessonOrderDataItems(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const fetchMckessonOrderItemAPI = async (data: any) => {
    try {
      const response: any = await fetchMckessonOrderItem(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const markMckessonOrderProcessedAPI = async (data: any) => {
    try {
      const response: any = await markMckessonOrderProcessed(data).unwrap();
      toast.success("Success! Item marked as processed.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  // --- Items Master APIs ---
  const getMckessonItemsAPI = async (data: any) => {
    try {
      const response: any = await getMckessonItems(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getMckessonUomsAPI = async (data: any) => {
    try {
      const response: any = await getMckessonUoms(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonItemSearchAPI = async (data: any) => {
    try {
      const response: any = await postMckessonItemSearch(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonItemFeedAPI = async (data: any) => {
    try {
      const response: any = await postMckessonItemFeed(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postMckessonItemLookupAPI = async (data: any) => {
    try {
      const response: any = await postMckessonItemLookup(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  return {
    // Vendor Detail
    getMckessonVendorDetailAPI,
    getMckessonVendorDetailLoading,
    postMckessonVendorDetailAPI,
    postMckessonVendorDetailLoading,
    putMckessonVendorDetailAPI,
    putMckessonVendorDetailLoading,
    // Shipping Locations
    getMckessonShippingLocationsAPI,
    getMckessonShippingLocationsLoading,
    postMckessonShippingLocationAPI,
    postMckessonShippingLocationLoading,
    putMckessonShippingLocationAPI,
    putMckessonShippingLocationLoading,
    deleteMckessonShippingLocationAPI,
    deleteMckessonShippingLocationLoading,
    // APIs
    getMckessonApisAPI,
    getMckessonApisLoading,
    postMckessonApiAPI,
    postMckessonApiLoading,
    putMckessonApiAPI,
    putMckessonApiLoading,
    deleteMckessonApiAPI,
    deleteMckessonApiLoading,
    // EDI / Order Processor
    getMckessonEdiFileListAPI,
    getMckessonEdiFileListLoading,
    getMckessonEdiItemListAPI,
    getMckessonEdiItemListLoading,
    getMckessonEdiHeaderListAPI,
    getMckessonEdiHeaderListLoading,
    getMckessonOrderFilesAPI,
    getMckessonOrderFilesLoading,
    getMckessonOrderDataItemsAPI,
    getMckessonOrderDataItemsLoading,
    fetchMckessonOrderItemAPI,
    fetchMckessonOrderItemLoading,
    markMckessonOrderProcessedAPI,
    markMckessonOrderProcessedLoading,
    // Items Master
    getMckessonItemsAPI,
    getMckessonItemsLoading,
    getMckessonUomsAPI,
    getMckessonUomsLoading,
    postMckessonItemSearchAPI,
    postMckessonItemSearchLoading,
    postMckessonItemFeedAPI,
    postMckessonItemFeedLoading,
    postMckessonItemLookupAPI,
    postMckessonItemLookupLoading,
  };
}
